import * as React from 'react';
import * as S from './styles';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { IReviewsListProps } from './types';
import { orderByValuesSend,OrderByValues, FacebookRecommended } from './Filters/types';
import TopTextInput from '../TopTextInput';
import Filters from './Filters';
import List from './List';
import { SearchableDropdownItem } from 'components/SearchableDropdown/constants';
import { Divider } from '@material-ui/core';
import { getReviewsFiltered } from '../../state/utils';
import { RootState } from 'store/types';
import { TC_BUTTON_TYPE } from 'components/TCButton/constants';
import { TCButton } from 'components/TCButton';
import { Provider } from '../../state/types';
import { Context } from '../../context';
import { createRGBA } from '../../state/utils';
import { cloneDeep } from 'lodash';
import { Widgets, ReviewListConfig} from '../../state/types';
import { saveWidgetsConfig } from '../../state/utils';
import { IShowRatings } from './types';
import SelectRatings from './SelectRatings';
import EmptyMessage from '../EmptyMessage';

const ReviewsList: React.FC<IReviewsListProps> = (props) => {
    const [showRatingsSelector, setShowRatingsSelector] = React.useState<IShowRatings>({ show: false });
    const [sourceList, setSourceList] = React.useState<SearchableDropdownItem[]>([]);
    const [filterSource, setFilterSource] = React.useState<SearchableDropdownItem|undefined>(undefined);
    const [ratingsList, setRatingsList] = React.useState<SearchableDropdownItem[]>([]);
    const [filterRating, setFilterRating] = React.useState<SearchableDropdownItem|undefined>(undefined);
    const [allRating, setAllRating] = React.useState<boolean>(false);
    const [allSource, setAllSource] = React.useState<boolean>(false);
    const [orderBy, setOrderBy] = React.useState<SearchableDropdownItem|undefined>(undefined);
    const [keyWords, setKeyWords] = React.useState<string[]|undefined>(undefined);
    const [start, setStart] = React.useState<number>(0);
    const [loading, setLoading] = React.useState<boolean>(false);
    const pagelength = 5 ;
    const dispatch = useDispatch();
    const context = React.useContext(Context);

    const {
        selectedDealerId,
        reviewsFiltered,
        widgets
    } = useSelector((rootState: RootState) => {
        return {
            selectedDealerId: rootState.dealers.dealer.selectedDealer?.id,
            reviewsFiltered: rootState.reviews.reviewsFiltered,
            widgets: rootState.reviews.widgets,
        };
    }, shallowEqual);

    const getReviews = async (idDealer: string, startOptional?: number) => {
        let query = `start=${startOptional??start}&pagelength=${pagelength}`;
        if (filterSource && filterSource.displayName!=='All') query+=`&providers=${filterSource.displayName}`;
        else {
            let sources: Provider[]| undefined = (props.selectedTab==="individual") 
                ? widgets?.individualConfig.reviewList.providers
                : widgets?.entireConfig.reviewList.providers;
            if (sources) {
                query+=`&providers=`;
                sources.forEach((provider: Provider) => query+=`${provider.name},`);
                query = query.slice(0, -1);
            }
        }
        if (filterRating && filterRating.displayName!=='All') {
            if (filterSource?.displayName==='FACEBOOK' && filterRating.id!=='0') query+=`&recommended=${filterRating.id==='1'}`;
            else if (filterSource?.displayName!=='FACEBOOK') query+=`&ratings=${filterRating.displayName.substring(0,1)}`;
        }
        else {
            if (filterSource?.displayName==='FACEBOOK' && filterRating && filterRating.id!=='0') query+=`&recommended=${filterRating.id==='1'}`;
            else if (filterSource?.displayName!=='FACEBOOK') {
                let ratings: number[]| undefined = (props.selectedTab==="individual") 
                ? widgets?.individualConfig.reviewList.ratingOptions
                : widgets?.entireConfig.reviewList.ratingOptions
                if (ratings) {
                    query+=`&ratings=`;
                    ratings.forEach((rating: number) => query+=`${rating.toString()},`);
                    query = query.slice(0, -1);
                }
            }
        }
        if (keyWords && keyWords?.length>0) {
            query+=`&keywords=`;
            keyWords.forEach( (keyWord: string) => query+=`${keyWord},`)
            query = query.slice(0, -1);
        }
        if (orderBy) {
            let searchValue = orderByValuesSend.find( (value: any) => value.id===orderBy.id);
            if (searchValue) query+=`&orderby=${searchValue.orderby}`;
        }

        if (startOptional) setStart(startOptional);
        try {
            setLoading(true);
            await getReviewsFiltered(dispatch, query, idDealer);
        } catch(e) {
            console.error(e);
            setLoading(false);
        }
    };

    React.useEffect(() => {
        setLoading(false);
    }, [reviewsFiltered]);

    React.useEffect(() => {
        if (selectedDealerId && (filterSource || filterRating || keyWords || orderBy)) {
            getReviews(selectedDealerId??'', 0);
        }
    }, [filterSource, filterRating, keyWords, orderBy, selectedDealerId]);

    React.useEffect(() => {
        if ((!filterSource || filterSource.displayName != "FACEBOOK")) {
            if (filterRating) {
                const ratingFound = ratingsList.filter((rating) => { return rating.displayName === filterRating?.displayName});
                if (!ratingFound || ratingFound.length === 0) {
                    setFilterRating({id: 'all', displayName: 'All'});
                }
            }
            else {
                if (selectedDealerId && (filterSource || filterRating || keyWords || orderBy)) {
                    getReviews(selectedDealerId??'', 0);
                }
            }
        }
    }, [ratingsList]);

    React.useEffect(() => {
        if (props.selectedTab && widgets) {
            setStart(0);

            let newsource : SearchableDropdownItem[] = [{ id: 'all', displayName: 'All' },];
            if (props.selectedTab==="individual")
                widgets.individualConfig.reviewList.providers?.forEach ((provider: Provider, index: number) => newsource.push({ id: `${index}`, displayName: provider.name}) )
            else widgets.entireConfig.reviewList.providers?.forEach ((provider: Provider, index: number) => newsource.push({ id: `${index}`, displayName: provider.name}) ) 
            setSourceList(newsource);

            let newRatings : SearchableDropdownItem[] = [{ id: 'all', displayName: 'All' },];
            if (props.selectedTab==="individual")
                widgets.individualConfig.reviewList.ratingOptions?.forEach ((rating: number) => newRatings.push({ id: `${rating}`, displayName: rating.toString() + (rating>1?" stars":" star")}) )
            else widgets.entireConfig.reviewList.ratingOptions?.forEach ((rating: number) => newRatings.push({ id: `${rating}`, displayName: rating.toString() + (rating>1?" stars":" star")}) ) 
            setRatingsList(newRatings);

            let sourceShow : SearchableDropdownItem | undefined = undefined;
            let ratingShow : SearchableDropdownItem | undefined = undefined;
            let orderByShow : SearchableDropdownItem | undefined = undefined;
            let keyWordsShow: string[]|undefined = undefined;
            const page: string = `${props.selectedTab}Config`;
            if (widgets[page].reviewList.configuration!==undefined && widgets[page].reviewList.configuration!==null) {
                const configuration: ReviewListConfig = widgets[page].reviewList.configuration;
                if (configuration.source) {
                    sourceShow = newsource.find( (val: SearchableDropdownItem) => val.displayName===configuration.source || val.id===configuration.source);
                    if (sourceShow?.id==='all' && !allSource) sourceShow = undefined;
                }
                if (configuration.rating && sourceShow?.displayName!=='FACEBOOK')
                    ratingShow = ratingsList.find( (val: SearchableDropdownItem) => val.id===configuration.rating);
                if (sourceShow?.displayName==='FACEBOOK') {
                    const idSearch: string = configuration.recommended===null ? allRating ? '0' : '' : configuration.recommended ? '1' : '2';
                    ratingShow = FacebookRecommended.find( (val: SearchableDropdownItem) => val.id===idSearch);
                }
                if (configuration.sortBy) {
                    let searchValue = orderByValuesSend.find( (val: any) => val.orderby===configuration.sortBy);
                    if (searchValue) orderByShow = OrderByValues.find( (val: SearchableDropdownItem) => val.id===searchValue.id);
                }
                if (configuration.keywords) keyWordsShow = configuration.keywords;
            }
            
            if (filterSource?.displayName!==sourceShow?.displayName) setFilterSource(sourceShow);
            setFilterRating(ratingShow);
            setOrderBy(orderByShow??{ id: '02', displayName: 'Most Recent' });
            if (keyWords?.every(elem => keyWordsShow?.includes(elem))===false || keyWords===undefined) setKeyWords(keyWordsShow);
        }
    }, [props.selectedTab, widgets]);

    const handleUpdateWidgetFilters = async (filter: string, value?: SearchableDropdownItem, keywords?: string[] ) => {
        let updateWidgets: Widgets|undefined = cloneDeep(widgets);
        if (updateWidgets) {
            const page: string = `${props.selectedTab}Config`;
            if (updateWidgets[page].reviewList.configuration===undefined || updateWidgets[page].reviewList.configuration===null) {
                updateWidgets[page].reviewList.configuration = {
                    source: '',
                    rating: '',
                    sortBy: 'c.date DESC',
                };
            }
            if (value) {
                if (filter==='source') {
                    updateWidgets[page].reviewList.configuration[filter] = value.displayName;
                    if (value.id==='all') {
                        updateWidgets[page].reviewList.configuration[filter] = value.id;
                        setAllSource(true);
                    } else updateWidgets[page].reviewList.configuration[filter] = value.displayName;
                    if (value.displayName==='FACEBOOK') updateWidgets[page].reviewList.configuration.rating = null;
                    else {
                        updateWidgets[page].reviewList.configuration.recommended = null;
                        setAllRating(false);
                    }
                } else if (filter==='recommended') {
                    updateWidgets[page].reviewList.configuration[filter] = value.id==='0' ? null : value.id==='1';
                    if (value.id==='0') setAllRating(true);
                    else setAllRating(false);
                } else if (filter==='sortBy') {
                    let searchValue = orderByValuesSend.find( (val: any) => val.id===value.id);
                    if (searchValue) updateWidgets[page].reviewList.configuration[filter] = searchValue.orderby;
                } else updateWidgets[page].reviewList.configuration[filter] = value.id;
            }
            if (keywords) updateWidgets[page].reviewList.configuration.keywords = keywords;
            try {
                await saveWidgetsConfig(dispatch, updateWidgets);
            } catch(e) {
                console.error(e);
            }
        }
        
    }

    const starColor= context.editingStatus.star?.id === "reviewList" ? createRGBA(context.editingStatus.star.color ?? "#FFD84D", context.editingStatus.star.opacity) : createRGBA(props.widgetsConfig.reviewList.starColor ?? "#FFD84D", props.widgetsConfig.reviewList.starOpacity);
    const buttonColor= context.editingStatus.star?.id === "reviewList" ? createRGBA(context.editingStatus.button?.color ?? "#4da0ff", context.editingStatus.button?.opacity) : createRGBA(props.widgetsConfig.reviewList.buttonColor ?? "#4da0ff", props.widgetsConfig.reviewList.buttonOpacity);
    const buttonTextColor= context.editingStatus.star?.id === "reviewList" ? createRGBA(context.editingStatus.buttonText?.color ?? "#fff", context.editingStatus.buttonText?.opacity) : createRGBA(props.widgetsConfig.reviewList.buttonTextColor ?? "#fff", props.widgetsConfig.reviewList.buttonTextOpacity);
    const titleColor = context.editingStatus.titleText?.id === "reviewList" ? context.editingStatus.titleText.color : props.widgetsConfig.reviewList.titleTextColor ?? "#000000";
    const bodyColor = context.editingStatus.bodyText?.id === "reviewList" ? context.editingStatus.bodyText.color : props.widgetsConfig.reviewList.bodyTextColor ?? "#000000";

    const hasProviders = props.widgetsConfig.reviewList?.providers && props.widgetsConfig.reviewList.providers.length > 0;

    const renderRatingsSelector = () =>{
        return (showRatingsSelector.show) ? (
            <SelectRatings
            selectedTab={props.selectedTab}
            widgetsConfig={props.widgetsConfig}
            onClose={() => setShowRatingsSelector({show: false})}
            {...showRatingsSelector}
          />
        ):'';
    }

    return (
        <S.Root>
            <S.Title>
                <TopTextInput
                    {...props}
                    textTag={props.widgetsConfig.reviewList.titleTag}
                    widgetType={"reviewList"}
                    style={{height: "68px"}}
                    textStyle={{
                        color: titleColor,
                    }}
                    inputStyle={{
                        width: "411px",
                        height: "42px",
                        border: "solid 2px #e7e7ec",
                        borderRadius: "5px",
                        color: titleColor,
                    }}
                />
            </S.Title>
            <S.ContainerCenter>
            <S.Container>
                <Filters filterSource={filterSource} filterRating={filterRating} orderBy={orderBy} keyWords={keyWords??[]}
                bodyColor={bodyColor}
                setFilterSource={(value: SearchableDropdownItem) => {
                    setFilterSource(value);
                    handleUpdateWidgetFilters('source', value);
                }}
                setFilterRating={(value: SearchableDropdownItem, filter: string) => {
                    setFilterRating(value);
                    handleUpdateWidgetFilters(filter, value);
                }}
                setOrderBy={(value: SearchableDropdownItem) => {
                    setOrderBy(value);
                    handleUpdateWidgetFilters('sortBy', value);
                }}
                setKeyWords={(keywords: string[]) => {
                    setKeyWords(keywords);
                    handleUpdateWidgetFilters('keywords', undefined, keywords);
                }}
                selectedTab={props.selectedTab}
                handleEditProviders={props.handleEditProviders}
                handleEditRatings={(values: any) =>
                    setShowRatingsSelector(values)
                }
                ratingsList={ratingsList}
                editRatingsList={!(filterSource?.displayName==='FACEBOOK')}
                sourceList={sourceList}/>
                <Divider/>
                {
                    !hasProviders ?
                        <EmptyMessage
                            message="Search for and select reviews to show here"
                            containerStyle={{height: "400px"}}
                        />
                        :
                        <List starColor={starColor} bodyColor={bodyColor} />
                }
            </S.Container>
            </S.ContainerCenter>
            {(reviewsFiltered?.start!==undefined && (reviewsFiltered?.start+4<reviewsFiltered?.total)) &&
            <S.ButtonContainer>
                <TCButton
                    type={TC_BUTTON_TYPE.SECONDARY}
                    onClick={() => getReviews(selectedDealerId??'',reviewsFiltered.start+pagelength)}
                    backgroudColor={buttonColor}
                    disabled={loading}
                >
                    <S.ButtonText buttonTextColor={buttonTextColor}>Load More Reviews</S.ButtonText>
                </TCButton>
            </S.ButtonContainer>}
            {
                renderRatingsSelector()
            }
        </S.Root>
    )
}

export default ReviewsList;
